import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/a3b81742d90ab9f1e4ddf3ee0c6174cb.png"
              alt="Atlas AI Services"
              className="h-10 w-auto"
            />
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#industries"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
              }`}
            >
              Industries
            </a>
            <a
              href="#framework"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
              }`}
            >
              Framework
            </a>
            <a
              href="#results"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
              }`}
            >
              Results
            </a>
            <button className="px-5 py-2.5 bg-[#0F172A] text-white text-sm font-medium hover:bg-[#1e293b] transition-colors cursor-pointer whitespace-nowrap">
              Contact
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}